<!-- begin main content -->
<div class="container" role="main" id="main-content">
  <div class="row">
    <div class="col-md-12 acl-container" style="min-height: 500px;">
      <oaaps-dashboards-titlevi-side-nav  (menuSelcted)="selctedMenu($event)"></oaaps-dashboards-titlevi-side-nav>
      <div class="col-md-9 background-gray-lighter-card-exp mb-1">
        <h1>{{selctedMenuNav.subNav.pageTitle}}</h1>
        <h2 class="graphDesc">You are currently viewing the {{selctedMenuNav.subNav.pageTitle}} data for your Tribe's performance over the
          past 5 years, as submitted on the OAAPS site. The information you enter is important, as it influences your
          funding for the coming year.</h2>
      </div>
      <div class="col-md-9 details">
        <div class="col-md-6">
          <h2>{{selctedMenuNav.subNav.title}}</h2>
          <p>{{selctedMenuNav.subNav.subTitle}}</p>
          <h2 *ngIf="lastDataRefreshDate.length > 0" class="last-update">Last Updated: {{lastDataRefreshDate}} <sup> <i class="fa fa-info-circle blue-tooltip" data-toggle="tooltip"
            data-placement="top" title="Data is not updated instantly. This date indicates when data was last refreshed" tabindex="0" aria-label="Data is not updated instantly. This date indicates when data was last refreshed"></i></sup></h2>
        </div>
        <div class="col-md-3 kpi">
          <p class="kpiTitle"><strong>This Year You Served</strong></p>
          <p class="numbers"><strong>{{kpiNumbers}}</strong> {{YAxisLabel}}</p>
          <p class="variance"><strong>{{kpiPercentage}}</strong> Variance from last Year</p>
          <div *ngIf="showvarianceWarning"  role="alert" class="alert alert-warning">
          <div class="inline">
            <i aria-hidden="true" class="fa fa-exclamation-triangle"> <p class="variance-warning">Variance DOES NOT fall within the 30% threshold</p></i>
            <span class="sr-only">Variance Warning</span>
          </div>
        </div>
        </div>
      </div>
      <div class="col-md-9">
        <acl-state-single-select  [fromDashboardsPage]="true" [fromTitleVI]="true" [isAclUser]="isACLUser"
          (selectedSingleState)="selectedState($event)"></acl-state-single-select>
          <div class="chart" [chart]="Chart"></div>
      </div>
    </div>
  </div>
</div>